const ToolUtil = {
  /**
   * 计算两个经纬度的距离(千米)
   */
  getDistance: (lat1, lng1, lat2, lng2) => {
    var radLat1 = (lat1 * Math.PI) / 180.0
    var radLat2 = (lat2 * Math.PI) / 180.0
    var a = radLat1 - radLat2
    var b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0
    var s =
      2 *
      Math.asin(
        Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2))
      )
    s = s * 6378.137 // EARTH_RADIUS
    s = Math.round(s * 10000) / 10000
    return s
  },
  /**
   * 坐标转换，百度地图坐标转换成腾讯地图坐标
   * lng 腾讯经度（pointy）
   * lat 腾讯纬度（pointx）
   * 经度>纬度
   */
  bMapToQQMap: (lng, lat) => {
    if (lng == null || lng == '' || lat == null || lat == '')
      return [lng, lat]
    const x_pi = 3.14159265358979324
    const x = parseFloat(lng) - 0.0065
    const y = parseFloat(lat) - 0.006
    const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi)
    const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi)
    lng = (z * Math.cos(theta)).toFixed(7)
    lat = (z * Math.sin(theta)).toFixed(7)
    return [lng, lat]
  },
  /**
   * 坐标转换，腾讯地图转换成百度地图坐标
   * lng 腾讯经度（pointy）
   * lat 腾讯纬度（pointx）
   * 经度>纬度
   */
  qqMapToBMap: (lng, lat) => {
  if (lng == null || lng == '' || lat == null || lat == '')
    return [lng, lat]
    const x_pi = 3.14159265358979324
    const x = parseFloat(lng)
    const y = parseFloat(lat)
    const z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi)
    const theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi)
    lng = (z * Math.cos(theta) + 0.0065).toFixed(5)
    lat = (z * Math.sin(theta) + 0.006).toFixed(5)
    return [lng, lat]
  },
  /**
   * 火星坐标系 (GCJ-02) 与百度坐标系 (BD-09) 的转换
   * 即谷歌、高德 转 百度
   * @param lng
   * @param lat
   * @returns {*[]}
   */
  gcj02tobd09: (lng, lat) => {
    var x_PI = 3.14159265358979324 * 3000.0 / 180.0;
    var z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_PI);
    var theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI);
    var bd_lng = z * Math.cos(theta) + 0.0065;
    var bd_lat = z * Math.sin(theta) + 0.006;
    return [bd_lng, bd_lat]
  },
  isPassCardCode: code => {
    // 身份证号合法性验证
    // 支持15位和18位身份证号
    // 支持地址编码、出生日期、校验位验证
    const city = {
      11: '北京', 12: '天津', 13: '河北', 14: '山西', 15: '内蒙古', 21: '辽宁', 22: '吉林', 23: '黑龙江', 31: '上海', 32: '江苏',
      33: '浙江', 34: '安徽', 35: '福建', 36: '江西', 37: '山东', 41: '河南', 42: '湖北', 43: '湖南', 44: '广东', 45: '广西',
      46: '海南', 50: '重庆', 51: '四川', 52: '贵州', 53: '云南', 54: '西藏', 61: '陕西', 62: '甘肃', 63: '青海', 64: '宁夏',
      65: '新疆', 71: '台湾', 81: '香港', 82: '澳门', 91: '国外'
    }
    let row = { 'pass': true, 'msg': '' }
    if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(code)) {
      row = { 'pass': false, 'msg': '身份证号格式错误' }
    } else if (!city[code.substr(0, 2)]) {
      row = { 'pass': false, 'msg': '身份证号地址编码错误' }
    } else {
      // 18位身份证需要验证最后一位校验位
      if (code.length === 18) {
        code = code.split('')
        // ∑(ai×Wi)(mod 11)
        // 加权因子
        const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
        // 校验位
        const parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
        let sum = 0
        let ai = 0
        let wi = 0
        for (let i = 0; i < 17; i++) {
          ai = code[i]
          wi = factor[i]
          sum += ai * wi
        }
        if (parity[sum % 11].toString() !== code[17].toUpperCase()) {
          row = { 'pass': false, 'msg': '身份证号校验位错误' }
        }
      }
    }
    return row
  },
  /**
   * 根据身份证获取出生日期（yyyy-MM-dd）
   * @param psidno
   * @returns { String }
   * @constructor
   */
  getBirthday(psidno) {
    let birthdayno, birthdaytemp
    if (psidno.length === 18) {
      birthdayno = psidno.substring(6, 14)
    } else if (psidno.length === 15) {
      birthdaytemp = psidno.substring(6, 12)
      birthdayno = '19' + birthdaytemp
    } else {
      return ''
    }
    const birthday = birthdayno.substring(0, 4) + '-' + birthdayno.substring(4, 6) + '-' + birthdayno.substring(6, 8)
    return birthday
  },
  /**
   *根据输入的身份证获取性别代码
   * @param psidno
   * @returns {Number, String}
   * @constructor
   */
  getSex(psidno) {
    let sexno
    if (psidno.length === 18) {
      sexno = psidno.substring(16, 17)
    } else if (psidno.length === 15) {
      sexno = psidno.substring(14, 15)
    } else {
      return ''
    }
    const sex = sexno % 2
    return sex === 0 ? 2 : sex
  },
  /**
   * 根据地图类型、位置获取不同的地图页面跳转链接
   * @param {*} mapType 地图类型
   * @param {*} location 经纬度 lat:纬度 lng:经度
   * @param {*} address 详细地址
   */
  getMapApp(mapType, location, address) {
    const { lat, lng } = location;
    let url = '';
    switch(mapType) {
      case '腾讯地图':
        url = 'https://apis.map.qq.com/uri/v1/marker?marker=coord:' + lat + ',' +  lng +';addr:'+ address +';title:地址&referer=keyfree';
        break;
      case '高德地图':
        url = 'https://uri.amap.com/marker?position='+ lng + ',' + lat +'&name='+ address +'&callnative=1';
        break;
      case '百度地图':
        url = 'https://api.map.baidu.com/marker?location=' + lat + ',' +  lng +'&title=地址&content='+ address +'&output=html&src=webapp.reformer.appname&coord_type=gcj02';
        break;
      default:
        break;
    }
    return url;
  },
  // 判断是不是在小程序中
  getMiniProgram() {
    return new Promise((resolve) => {
      const ua = navigator.userAgent.toLowerCase()
      // eslint-disable-next-line
      if (ua.match(/MicroMessenger/i) == 'micromessenger' ) {
        // ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        // eslint-disable-next-line
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            resolve(true)
          } else {
            resolve(false)
          }
        })
      } else {
        resolve(false)
      }
    })
  },
  getDeviceType(){
    let equipmentType = "";
    let agent = navigator.userAgent.toLowerCase()
    let android = agent.indexOf("android")
    let iphone = agent.indexOf("iphone")
    let ipad = agent.indexOf("ipad")
    if(android != -1){
      equipmentType = "android"
    }
    if(iphone != -1 || ipad != -1){
      equipmentType = "ios"
    }
    return equipmentType
  }
}

export { ToolUtil }
